import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const UpspaceLogoMark = (props: SvgProps) => (
  <Svg width='502' height='743' viewBox='0 0 502 743' fill='currentColor' {...props}>
    <Path
      d='M251.072 742.055C112.714 742.055 0.512695 629.854 0.512695 491.496V355.522C0.512695 347.668 5.141 340.515 12.2938 337.36L72.041 310.782V491.496C72.041 590.303 152.195 670.457 251.002 670.457C349.809 670.457 429.963 590.303 429.963 491.496V199.212C429.963 191.358 434.591 184.205 441.744 181.049L501.491 154.472V491.496C501.491 629.854 389.29 742.055 250.932 742.055H251.072Z'
      fill='currentColor'
    />
    <Path
      d='M251.058 634.701C172.026 634.701 107.861 570.606 107.861 491.504V122.853C107.861 114.999 112.49 107.846 119.642 104.69L179.39 78.1125V491.504C179.39 531.055 211.437 563.102 250.988 563.102C290.539 563.102 322.586 531.055 322.586 491.504V83.7225C322.586 75.8685 327.215 68.7156 334.368 65.56L394.115 38.9823V491.504C394.115 570.536 330.02 634.701 250.918 634.701H251.058Z'
      fill='currentColor'
    />
    <Path
      d='M251.062 527.339C231.287 527.339 215.298 511.28 215.298 491.575V45.0142C215.298 37.1601 219.926 30.0073 227.079 26.8516L286.826 0.273926V491.505C286.826 511.28 270.767 527.269 251.062 527.269V527.339Z'
      fill='currentColor'
    />
  </Svg>
)
